/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:08
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-21 10:09:12
 * @FilePath: \ioc_base\src\common\config\theme.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 主题配置
export default {
  // 页面主题列表配置
  THEME_MAP: {
    default: {
      // Element-UI库的主颜色值，切换该主题后，Element-UI所有组件的样式将使用该颜色值，该颜色值必须为16进制颜色值
      mainColor: "#00e8bb",
      // 主题样式的命名空间，该样式将设置为body的样式，所有自定义主题样式写在该样式内
      // 该样式命名空间必须与src/assets/theme/xxx主题目录下的命名空间一致
      className: "default-theme",
      // 主题对应的图片地址，该图片地址主要用于js代码中获取对应图标时使用的路径
      imagePath: "default",
      // 主题名称，用户操作时，用于展示主题名称，该配置使用国际化中的字符串配置信息
      themeName: "system.theme.default"
    },
    dark: {
      mainColor: "#4a6ac7",
      className: "dark-theme",
      imagePath: "dark",
      themeName: "system.theme.dark"
    },
    light: {
      mainColor: "#409eff",
      className: "light-theme",
      imagePath: "light",
      themeName: "system.theme.light"
    },
    newDark: {
      // mainColor: "#2e86e8",// "#2B53A1",//"#2B53A1", // '#161B29',
      mainColor: "#2B5692",// "#2B53A1",//"#2B53A1", // '#161B29',
      className: "newDark-theme",
      imagePath: "new",
      themeName: "system.theme.newDark"
    }
  },
  // 系统默认主题，配置该默认主题时
  // 1、需要修改assert/style/default.scss中的$--color-primary值为对应主题的mainColor值
  // 2、需要修改public/index.html页面中body的class值为对应主题的className值
  DEFAULT_THEME: "newDark",
  // Element-UI组件的初始主题颜色值，该值固定为“#409EFF”，请勿改动
  // 1、该值与public/theme/elementUi/index.css中的颜色值一致，如果index.css中的主色值发生变化，该值也进行相应改变
  // 2、该颜色值类型必须为16进制颜色值
  ORIGINAL_THEME: "#409EFF"
};
